import { useEffect } from 'react';

import { Navigate } from '@sorare/routing';
import {
  ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION,
  ANY_SPORT_ONBOARDING_SERIES_WELCOME,
  FOOTBALL_ONBOARDING_TUTORIAL,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage';
import { useFootballEvents } from '@sorare/marketplace/src/shared/events/lib';

const ProOnboardingPage = () => {
  const track = useFootballEvents();
  const {
    flags: { skipSeriesOnboardingDialogs = false },
  } = useFeatureFlags();
  const { generateSportContextPath } = useSportContext();
  const [onboardingPro] = useLocalStorage('ONBOARDING_PRO', undefined);

  useEffect(() => {
    track('Enter General Tutorial');
  }, [track]);

  if (onboardingPro) {
    return <Navigate to={FOOTBALL_ONBOARDING_TUTORIAL} replace />;
  }

  if (skipSeriesOnboardingDialogs) {
    return (
      <Navigate
        to={generateSportContextPath(
          ANY_SPORT_ONBOARDING_SERIES_SELECT_COMPETITION
        )}
        replace
      />
    );
  }
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_ONBOARDING_SERIES_WELCOME)}
      replace
    />
  );
};

export default ProOnboardingPage;
